import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { DocumentacionRequeridaModel } from 'src/app/models/solicitud/DocumentacionRequeridaModel';
import { SolicitudModel } from 'src/app/models/solicitud/SolicitudModel';
import { SolicitudService } from 'src/app/services/solicitud/solicitud.service';

import {
  DocumentoTipoRequisito,
  EstadoSolicitud,
  eTipoCreacion,
  eTypeResult,
  ParametrosMaestro,
  SolicitudSeccion,
} from 'src/app/models/common/enumModel';
import { Router } from '@angular/router';
import { ISolicitudModel } from 'src/app/models/interfaces/ISolicitudModel';

import { ConfiguracionDocumentoService } from 'src/app/services/configuracion-documento/configuracion-documento.service';
import { IFilterConfiguracionDocumentoModel } from 'src/app/models/interfaces/configuracion-documento/IFilterConfiguracionDocumentoModel';
import { FilterConfiguracionDocumentoModel } from 'src/app/models/configuracion-documento/FilterConfiguracionDocumentoModel';
import {
  AdjuntarTipoDocumentoDialogComponent,
  AdjuntarTipoDocumentoModel,
} from '../../tipo-documento/adjuntar-tipo-documento-dialog/adjuntar-tipo-documento-dialog/adjuntar-tipo-documento-dialog.component';
import { MatTable } from '@angular/material/table';
import { ControlContainer, NgForm } from '@angular/forms';
import { ISolicitudDocumentoTecnicoModel } from 'src/app/models/interfaces/solicitud/documento-tecnico/ISolicitudDocumentoTecnicoModel';
import { SolicitudDocumentoTecnicoModel } from 'src/app/models/solicitud/SolicitudDocumentoTecnicoModel';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { ParametroService } from 'src/app/services/parametros/parametro.service';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { ActionResultModel } from 'src/app/models/common/ActionResultModel';

@Component({
  selector: 'app-solicitud-engie-registrar',
  templateUrl: './solicitud-engie-registrar.component.html',
  styleUrls: ['./solicitud-engie-registrar.component.css'],
})
export class SolicitudEngieRegistrarComponent implements OnInit {
  displayedColumns: string[] = [
    'nombre',
    'requisito',
    'restringeAcceso',
    'acciones',
  ];

  public model!: ISolicitudModel;
  listaTipoRequisitos: ParametroModel[] = new Array<ParametroModel>();
  textoTodos: string = '';
  
  seccionPersonal: SolicitudSeccion = SolicitudSeccion.Personal;
  seccionEquipos: SolicitudSeccion = SolicitudSeccion.Equipos;
  seccionVehiculos: SolicitudSeccion = SolicitudSeccion.Vehiculos;
  seccionDocumentacionTecnica: SolicitudSeccion =
    SolicitudSeccion.DocumentacionTecnica;

  //  @ViewChild('tablePersonal', { static: true, read: MatTable })
  //  tablePersonal!: MatTable<any>;
  // @ViewChild('tableEquipos', { static: true, read: MatTable })
  // tableEquipos!: MatTable<any>;
  // @ViewChild('tableVehiculos', { static: true, read: MatTable })
  // tableVehiculos!: MatTable<any>;
  // @ViewChild('tableDocumentacionTecnica', { static: true, read: MatTable })
  // tableDocumentacionTecnica!: MatTable<any>;

  constructor(
    public dialog: MatDialog,
    private service: SolicitudService,
    private serviceParametros: ParametroService,
    private dialogService: ConfirmDialogService,
    private alertDialogService: AlertDialogService,
    private configuracionDocumentoService: ConfiguracionDocumentoService,
    private router: Router
  ) {
    this.model = new SolicitudModel();
    this.model.idTipoCreacion = eTipoCreacion.ENGIE;
  }

  ngOnInit(): void {
    this.serviceParametros
      .getDetalles(ParametrosMaestro.TIPO_REQUISITO)
      .subscribe((data) => {
        this.listaTipoRequisitos = data.items;
        let paramTodos = this.listaTipoRequisitos.find(
          (p) => p.idParametroDetalle == DocumentoTipoRequisito.TODOS
        );
        if (paramTodos) this.textoTodos = paramTodos.valor;
      });
  }

  getConfiguracionDocumentosPorTipoVisita(selectedValue: number) {
    const filterConfiguracionDocumentos: IFilterConfiguracionDocumentoModel =
      new FilterConfiguracionDocumentoModel();
    
    if(this.model.idTipoVisitaSelected)
      filterConfiguracionDocumentos.idTipoVisita = this.model.idTipoVisitaSelected;
      
    this.configuracionDocumentoService
      .getList(filterConfiguracionDocumentos)
      .subscribe((data: DocumentacionRequeridaModel[]) => {
        // console.log(data);
        data.forEach((p) => {
          p.esRequisitoBloqueado =
            p.idRequisito === DocumentoTipoRequisito.TODOS;
        });

        this.model.lista_documentos_personal = data.filter(
          (p) => p.seccion == SolicitudSeccion.Personal && p.esPredeterminado
        );
        this.model.lista_documentos_equipos = data.filter(
          (p) => p.seccion == SolicitudSeccion.Equipos && p.esPredeterminado
        );
        this.model.lista_documentos_vehiculos = data.filter(
          (p) => p.seccion == SolicitudSeccion.Vehiculos && p.esPredeterminado
        );

        this.model.documentosTecnicos = data
          .filter(
            (p) =>
              p.seccion == SolicitudSeccion.DocumentacionTecnica &&
              p.esPredeterminado
          )
          .map((item) => {
            let documento = new SolicitudDocumentoTecnicoModel();
            documento.idConfiguracionDocumento = item.idConfiguracionDocumento;
            documento.idMaestroDocumento = item.idMaestroDocumento;
            documento.documento = item.documento;
            documento.esPredeterminado = item.esPredeterminado;
            documento.idRequisito = item.idRequisito;
            // documento2.seccion = idSeccion;
            documento.controlarFechas = item.controlarFechas;
            documento.esRequisitoBloqueado =
              documento.idRequisito === DocumentoTipoRequisito.TODOS;

            return documento;
          });
      });
  }

  openDialogTipoDocumento(idSeccion: SolicitudSeccion): void {
    let tipoDocumento = new AdjuntarTipoDocumentoModel();
    tipoDocumento.idSeccion = idSeccion;
    
    if(this.model.idTipoVisitaSelected)
      tipoDocumento.idTipoVisita = this.model.idTipoVisitaSelected;

    switch (idSeccion) {
      case SolicitudSeccion.Personal: {
        tipoDocumento.listaTipoDocumentos = this.model.lista_documentos_personal;
        break;
      }
      case SolicitudSeccion.Equipos: {
        tipoDocumento.listaTipoDocumentos = this.model.lista_documentos_equipos;
        break;
      }
      case SolicitudSeccion.Vehiculos: {
        tipoDocumento.listaTipoDocumentos = this.model.lista_documentos_vehiculos;
        break;
      }
      case SolicitudSeccion.DocumentacionTecnica: {
        tipoDocumento.listaTipoDocumentos = this.model.documentosTecnicos.map((item) => {
          let documento = new DocumentacionRequeridaModel();
            documento.idConfiguracionDocumento = item.idConfiguracionDocumento;
            documento.documento = item.documento;
            documento.esPredeterminado = item.esPredeterminado;
            documento.idRequisito = item.idRequisito;
            documento.controlarFechas = item.controlarFechas;
            documento.esRequisitoBloqueado =
              documento.idRequisito === DocumentoTipoRequisito.TODOS;

            return documento;
        });
        break;
      }
    }
    // console.log(tipoDocumento);
    const dialogRef = this.dialog.open(AdjuntarTipoDocumentoDialogComponent, {
      width: '500px',
      data: tipoDocumento,
    });

    dialogRef.afterClosed().subscribe((result: AdjuntarTipoDocumentoModel) => {
      // this.animal = result;
      if (result) {
        let documento: DocumentacionRequeridaModel =
          new DocumentacionRequeridaModel();

        documento.idConfiguracionDocumento = result.idConfiguracionDocumento;
        documento.idMaestroDocumento = result.idMaestroDocumento;
        documento.documento = result.documento;
        documento.esPredeterminado = false;
        documento.idRequisito = result.idRequisito;
        documento.seccion = idSeccion;
        documento.controlarFechas = result.controlarFechas;
        documento.esRequisitoBloqueado =
          result.idRequisito === DocumentoTipoRequisito.TODOS;

        // console.log(documento.esRequisitoBloqueado);
        switch (idSeccion) {
          case SolicitudSeccion.Personal: {
            this.model.lista_documentos_personal.push(documento);
            const temp =  JSON.stringify(this.model.lista_documentos_personal);
            this.model.lista_documentos_personal = JSON.parse(temp);

            // tipoDocumento.listaTipoDocumentos.push(documento);            
            // this.model.lista_documentos_personal = [];
            // this.model.lista_documentos_personal = tipoDocumento.listaTipoDocumentos; //.push(documento);
            // this.tablePersonal.renderRows();
            break;
          }
          case SolicitudSeccion.Equipos: {
            this.model.lista_documentos_equipos.push(documento);
            const temp =  JSON.stringify(this.model.lista_documentos_equipos);
            this.model.lista_documentos_equipos = JSON.parse(temp);
            // this.tableEquipos.renderRows();
            break;
          }
          case SolicitudSeccion.Vehiculos: {
            this.model.lista_documentos_vehiculos.push(documento);
            const temp =  JSON.stringify(this.model.lista_documentos_vehiculos);
            this.model.lista_documentos_vehiculos = JSON.parse(temp);
            // this.tableVehiculos.renderRows();
            break;
          }
          case SolicitudSeccion.DocumentacionTecnica: {
            let documento2: SolicitudDocumentoTecnicoModel =
              new SolicitudDocumentoTecnicoModel();

            documento2.idConfiguracionDocumento = result.idConfiguracionDocumento;
            documento2.idMaestroDocumento = result.idMaestroDocumento;
            documento2.documento = result.documento;
            documento2.esPredeterminado = false;
            documento2.idRequisito = result.idRequisito;
            // documento2.seccion = idSeccion;

            documento2.controlarFechas = result.controlarFechas;
            documento2.esRequisitoBloqueado =
              result.idRequisito === DocumentoTipoRequisito.TODOS;

            this.model.documentosTecnicos.push(documento2);
            const temp =  JSON.stringify(this.model.documentosTecnicos);
            this.model.documentosTecnicos = JSON.parse(temp);
            // this.tableDocumentacionTecnica.renderRows();
            break;
          }
        }
      }
    });
  }

  submit() {
    this.model.idEstado = EstadoSolicitud.SOLICITADO;
  }

  save() {
    this.model.idEstado = EstadoSolicitud.EN_ELABORACION;
  }

  closed(){
    this.dialogService.open('Se perderán los cambios no guardados ¿esta seguro de salir?'); //options
          this.dialogService.confirmed().subscribe((confirmed) => {
            if (confirmed) {
              this.router.navigate(['/solicitudes-engie']);
            }
          });
  }

  onSubmit(form: NgForm) {
    if (form.invalid) {
      if (form.controls.notificarA.status == 'INVALID') {
        this.alertDialogService.open('Error en campo Notificar A (correo).');
      } else {
        this.alertDialogService.open('Debe ingresar en campos requeridos');
      }
    } else {
      if (this.model.idSedeSelected)
        this.model.idSede = this.model.idSedeSelected;

      if (this.model.idCompaniaSelected)
        this.model.idCompania = this.model.idCompaniaSelected;

      if (this.model.idTipoVisitaSelected)
        this.model.idTipoVisita = this.model.idTipoVisitaSelected;

      if (this.validar()) {
        if (
          this.model.idEstado == EstadoSolicitud.SOLICITADO &&
          this.model.lista_documentos_personal.length > 0
        ) {
          this.dialogService.open('¿Deseas guardar los cambios?'); //options
          this.dialogService.confirmed().subscribe((confirmed) => {
            if (confirmed) {              
              // this.saveData();
              this.submitForm();
            }
          });
        } else {
          this.submitForm();
        }
      }
    }
  }

  validar(): boolean {
    let errors = 0;

    if (this.model.idContratista === 0) {
      this.alertDialogService.open('Debe seleccionar un contratista');
      errors++;
    }

    if (
      this.model.idEstado == EstadoSolicitud.SOLICITADO &&
      this.model.lista_documentos_personal.length == 0
    ) {
      this.alertDialogService.open(
        'Debe registrar por lo menos un documento requerido en la seccion PERSONAL.'
      );
    }

    return errors == 0;
  }

  deletePersona(element: DocumentacionRequeridaModel): void {
    this.model.lista_documentos_personal =
      this.model.lista_documentos_personal.filter((item) => item !== element);
  }

  deleteEquipo(element: DocumentacionRequeridaModel): void {
    this.model.lista_documentos_equipos =
      this.model.lista_documentos_equipos.filter((item) => item !== element);
  }

  deleteVehiculo(element: DocumentacionRequeridaModel): void {
    this.model.lista_documentos_vehiculos =
      this.model.lista_documentos_vehiculos.filter((item) => item !== element);
  }

  deleteDocumentoTecnico(element: ISolicitudDocumentoTecnicoModel): void {
    this.model.documentosTecnicos = this.model.documentosTecnicos.filter(
      (item) => item !== element
    );
  }

  submitForm() {
    this.model.documentosRequeridos = [];

    this.model.lista_documentos_personal.forEach((p) => {
      this.model.documentosRequeridos.push(p);
    });
    this.model.lista_documentos_equipos.forEach((p) => {
      this.model.documentosRequeridos.push(p);
    });
    this.model.lista_documentos_vehiculos.forEach((p) => {
      this.model.documentosRequeridos.push(p);
    });
    
    if (
      (this.model.idEstado == EstadoSolicitud.SOLICITADO &&
        this.model.lista_documentos_personal.length > 0) ||
      this.model.idEstado == EstadoSolicitud.EN_ELABORACION
    ) {
      this.service.submit(this.model).subscribe((result : ActionResultModel) => {  
        if(result.type!=eTypeResult.SUCCESS){
          this.alertDialogService.open(result.message);
        }    
        else{  
          if (this.model.idEstado == EstadoSolicitud.SOLICITADO) {
            this.alertDialogService.open('La solicitud fue enviada.'); //options
            this.router.navigate(['/solicitudes-engie']);
          } else if (this.model.idEstado == EstadoSolicitud.EN_ELABORACION) {
            this.alertDialogService.open('La solicitud fue registrada.'); //options          
            this.router.navigate(['/solicitudes', result.recordId]);
          }
        }
      });
    }
  }
}
